export default __webpack_public_path__ + "static/media/error-img.97de789a.png";